/*requires hei.js */
//
// Standard javascript for most/all HEI forms
//
//  Ben Ramey
//  October 2009
//
HEIJS.Controls = function ()
{
  this.pageBottom = $("div.bottom");
  this.pageBottomOuterHeight = this.pageBottom.outerHeight();

  //this.setupTextAreas();
  this.setupEvents();
};

HEIJS.Controls.prototype =
{
  pageBottom: null,
  fieldIdCounter: 0,
  formIdCounter: 0,
  svcBaseUrl: HEIJS.context.convertToContextUri("https://svc.hendersonengineers.com"),

  resizeControls: function (controls, extraOffset)
  {
    var self = this;
    controls.each(function ()
    {
      var parentsBottomPadding = 0;
      controls.parents().each(function () { parentsBottomPadding += parseInt($(this).css("padding-bottom")); });

      $(this).height(
        $(window).height()
        - $(this).offset().top
        - (extraOffset || 0)
        - self.pageBottomOuterHeight
        - parentsBottomPadding
        - 6
      );
    });
  },

  setupTextAreas: function ()
  {
    var textAreasWidthMaxLength = $("textarea[maxlength]");

    if (textAreasWidthMaxLength.length == 0)
      return;

    var charsDiv = $("<div class='textarea-chars-remaining'><span></span> characters remaining</span>");
    $("body").append(charsDiv);

    textAreasWidthMaxLength
      .focus(function (e)
      {
        charsDiv.find("span").html($(this).attr("maxlength") - $(this).val().length);
        charsDiv.show();
        charsDiv.css({
          left: $(this).offset().left + $(this).outerWidth() - charsDiv.outerWidth(),
          top: $(this).offset().top - charsDiv.outerHeight()
        });
      })
      .blur(function (e) { charsDiv.hide(); })
      .keyup(
        function (e)
        {
          var maxLength = $(this).attr("maxlength");
          if ($(this).val().length > maxLength)
          {
            $(this).val($(this).val().substr(0, maxLength));
          }
          charsDiv.children("span").html(maxLength - $(this).val().length);
        }
      ).keyup();
  },

  handleControlHeightResize: function ()
  {
    this.resizeControls($(".auto-adjusts-height-to-page"));
  },

  createField: function (labelText, input, type)
  {
    var type = type || "normal";
    var field = $("<div class='field'>");
    field
      .append("<label></label>")
      .append("<div class='input'>");

    if (labelText == null || labelText == "")
    {
      field.attr("id", this.fieldIdCounter + "_field");
      this.fieldIdCounter++;
    }
    else
    {
      field.find("label").html(labelText);
      field.attr("id", labelText.replace(/[\s\W]+/g, "_").toLowerCase() + "_field");
    }

    if (input)
    {
      if (!input.attr("id"))
      {
        var id = field.attr("id").replace("_field", "_input");
        if ($("#" + id).length > 0)
          id = id + "_" + this.fieldIdCounter;
        input.attr("id", id);
      }

      field.find("label").attr("for", input.attr("id"));
      field.find("div.input").append(input);
    }

    if (type == "date")
      field.find("div.input").removeClass("input").addClass("date-input");
    else if (type == "text")
      field.find("div.input").removeClass("input").addClass("text-input");

    return field;
  },

  createForm: function ()
  {
    var form = $("<div class='form'>");
    form
      .attr("id", "dynamic_form_" + this.formIdCounter)
      .append($("<div class='ui-widget form-messages'>")
        .append($("<div class='ui-state-highlight ui-corner-all'>")
          .append($("<p>")
            .append("<span class='ui-icon ui-icon-info'></span>")
            .append("<span></span>")
          )
        )
        .append($("<div class='ui-state-error ui-corner-all'>")
          .append($("<p>")
            .append("<span class='ui-icon ui-icon-info'></span>")
            .append("<span></span>")
          )
        )
      )
      .append("<div class='action-buttons' style='display:none;'>")
      .append("<div class='controls'>");

    HEIJS.page.formMessages[form.attr("id")] = new HEIJS.Controls.FormMessages(form.find("div.form-messages"));

    this.formIdCounter++;
    return form;
  },

  addRequiredValidator: function (input)
  {
    var span = $("<span class='ui-state-highlight validator' style='color:Red;display:none;' message='Required'></span>");
    span.attr("id", input.attr("id") + "_requiredval");
    input.after(span);

    span[0].controltovalidate = input.attr("id");
    span[0].errormessage = "Required";
    span[0].display = "Dynamic";
    span[0].enabled = true;
    span[0].validationGroup = span.parents("div.form:first").attr("id");
    span[0].evaluationfunction = window.RequiredFieldValidatorEvaluateIsValid;
    span[0].initialvalue = "";

    Page_Validators.push(span[0]);
    ValidatorHookupControl(input[0], span[0]);
  },

  createActionButton: function (text, options)
  {
    var button = $("<a class='button ui-corner-all' isajax='true' causesvalidation='false'></a>");
    button.text(text);

    if (options != null)
    {
      if (typeof (options["iconCssClass"]) != "undefined")
      {
        button.prepend("<span class='ui-icon " + options["iconCssClass"] + "'></span>");
        delete options["iconCssClass"];
      }

      if (typeof (options["isSmall"]) != "undefined" && options["isSmall"])
      {
        button.removeClass("button").addClass("small-button");
      }

      for (var key in options)
      {
        button.attr(key, options[key]);
      }
    }

    return button;
  },

  addActionButtonsToForm: function (form, actionButtons)
  {
    var actionButtonDiv = form.find("div.action-buttons");
    if (actionButtonDiv.length == 0)
      return;

    actionButtonDiv.show();
    for (var idx = 0; idx < actionButtons.length; idx++)
    {
      actionButtonDiv.append(actionButtons[idx]);
    }
  },

  addControlsToForm: function (form, controls)
  {
    var controlsDiv = form.find("div.controls");
    if (controlsDiv.length == 0)
      return;

    for (var idx = 0; idx < controls.length; idx++)
    {
      controlsDiv.append(controls[idx]);
    }
  },

  // expects the fully qualified type name of the C# control to create
  createServerControl: function (type, url)
  {
    url = url || "/Services/ControlCreator.aspx";
    var control;
    $.ajax({
      url: url,
      data: { type: type },
      success: function (result) { control = $(result); },
      async: false
    });

    return control;
  },

  setupEvents: function ()
  {
    var self = this;

    $(window).resize(function (e) { self.handleControlHeightResize(); });
    this.handleControlHeightResize();
  }
};

$(function () { HEIJS.controls = new HEIJS.Controls(); });